export { formatPenalidadTooltip } from "@/services/liquidacion-reportes/liquidacion-reportes.formatters";

export function formatMoney(value) {
  if (value === null || value === undefined) return "0.00";

  return new Intl.NumberFormat("es-PE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatText(value) {
  if (value === null || value === undefined) return "";
  return String(value);
}
